import { IOffer } from '../../../../types/offer';

export function getClientFee(offer: IOffer, isDealRentCianAgency: boolean): string {
  let fee = offer.bargainTerms.clientFee ? `комиссия ${offer.bargainTerms.clientFee}%` : 'без комиссии';

  if (isDealRentCianAgency) {
    fee += ' в пользу Циан';
  }

  return fee;
}
